import {
  Image,
  Box,
  Flex,
  Heading,
  Stack,
  Text,
  Button,
  TabList,
  Tabs,
  Tab,
  TabPanels
} from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../components/shared/CommonContainer";

export default function CommunityPage() {
  const [tab,setTab]= React.useState("Introduction");
  return (
    <CommonContainer>
      <Stack my={{base:10,lg:20}}>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", md: "26px" }}
          pb={{base:5,xl:20}}
        >
          Decolance's Community Standards
        </Heading>
        <Flex justifyContent="space-between" alignItems="start" mb={10} flexDir={{base:"column",lg:"row"}} flexShrink={"none"}>
          <Box fontSize={"14px"} minWidth={{ lg: "200px" }} pr={3} display={{base:"none",lg:"block"}}>
            {
              list.map(item=>{
                return (
            <Text
              textDecoration={"underline"}
              color={tab === item?"brand.500":"gray.500"}
              cursor="pointer"
              key={item}
              onClick={()=>{setTab(item)}}
            >
              {item}
            </Text>

                )
              })
            }
          </Box>
          {/* Tabs for mobile */}
          <Tabs
            variant=""
            isFitted
            w="full"
            display={{ base: "block", lg: "none" }}
          >
            <TabList overflow="auto" w="full">
              {list.map((item) => {
                return (
                  <Tab
                    _selected={{ color: "white", bg: "brand.500" }}
                    bg="#f4f4f4"
                    onClick={() => {
                      setTab(item);
                    }}
                    key={item}
                    fontSize="12px"
                  >
                    {item}
                  </Tab>
                );
              })}
            </TabList>
            <TabPanels>
                <ContentOfAboveComponent tab={tab} />
            </TabPanels>
          </Tabs>
          <Box display={{base:"none",lg:"block"}}>
          <ContentOfAboveComponent tab={tab} />
          </Box>
        </Flex>
      </Stack>
    </CommonContainer>
  );
}
const ContentOfAboveComponent = ({tab})=>{
  return (
    <Box
            px={{ sm: 5, md: 10, xl: 20 }}
            fontSize={{ md: "19px" }}
            // w={{ xl: "85%" }}
            borderLeft={{lg:"1px"}}
            borderColor="gray.200"
            color="gray.500"
          >
            <Flex
              flexDir={{ base: "column-reverse", xl: "row" }}
              gap={{ base: 4, xl: 0 }}
            >
              <Box>
                <Heading
                  fontWeight={"semibold"}
                  pb={{ base: 2, md: 10 }}
                  fontSize={{ base: "21px", md: "26px" }}
                  color="black"
                >
             {tab}
                </Heading>
                <Text pb={2}>
                  <Image
                    src="/images/community/introduction.png"
                    px={{ xl: 20 }}
                    maxW="480px"
                    display={{ base: "none", xl: "block" }}
                    float={"right"}
                  />
                  We are cultivating a space for a community that aspires to
                  change the way the world functions collectively. We have
                  created a global network of writers, designers, producers,
                  videographers, business owners, and professionals from
                  hundreds of industries who use Decolance daily to create
                  something they believe in. Each and every member of our
                  community invigorates us. Their perspectives, beliefs, and
                  viewpoints are what makes Decolance so dynamic; we value them.
                </Text>
                <Text py={2}>
                  In order to maintain a courteous, inclusive, and secure
                  environment for all users, we've developed a set of community
                  standards to guide behavior on our platform. These standards
                  help define what is acceptable in the Decolance community and
                  marketplace, both in face-to-face interactions and online
                  communications. They are not tied to any particular law, but
                  they are used to govern our platform policies.
                </Text>
              </Box>
              <Image
                src="/images/community/introduction.png"
                maxW="480px"
                p={5}
                display={{ base: "block", xl: "none" }}
              />
            </Flex>
            <Text py={2}>
              They reflect our beliefs, expectations, and social conventions.
              Our community standards are based on our core values of courtesy,
              safety, acceptance, assistance, and tolerance.
              <br /> These standards will continue to grow, evolve, and change,
              just as our community does. We have embedded examples of
              unacceptable activities on Decolance into the community standards.
              Please note that this list is intended to serve as examples and is
              not exhaustive. We encourage our community to use our reporting
              tools when encountering anything that is unacceptable. We want to
              provide the best possible experience for all community members, so
              we ask that you abide by these rules.
            </Text>
            <Button bg="brand.500" color="white" px={10} py={6} my={4}>
              Next
            </Button>
          </Box>
  )
}
const list = [
  "Introduction","Integrity and Authenticity"
]